import React from 'react';
import { ActiveRecipientsInterface } from 'modules/static-pages/digital-services-act/digital-services-act.controller';
import PageSectionBox from 'components/pages/page-section-box/page-section-box';

import './digital-services-act.base.scss';

interface DigitalServicesActBaseInterface {
    activeRecipients: ActiveRecipientsInterface;
    isMobile?: boolean;
}

const DigitalServicesActBase: React.FC<DigitalServicesActBaseInterface> = ({
    activeRecipients
}) => {
    return (
        <section className="digital-services-act">
            <PageSectionBox
                headerText="Akt o Usługach Cyfrowych – informacja"
                padding="lg"
            >
                <h2>
                    Średnia miesięczna liczba aktywnych odbiorców usługi Cenojad.pl,
                    której dostawcą jest Ringier Axel Springer Polska sp. z o.o. z siedzibą w Warszawie (RASP).
                </h2>
                <p>
                    Zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2022/2065 z dnia 19 października 2022 r.
                    w sprawie jednolitego rynku usług cyfrowych oraz zmiany dyrektywy 2000/31/WE
                    (<a href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A32022R2065&amp;qid=1684434616250" id="f78ad9ff-1a64-4c81-976d-39fe2cf6729c">Akt o Usługach Cyfrowych</a>) - DSA,
                    dostawca usług pośrednich ma obowiązek publikować średnią miesięczną liczbę aktywnych odbiorców każdej dostarczanej platformy internetowej.
                    Publikacja ma pomóc organom publicznym zidentyfikować bardzo duże platformy internetowe.
                </p>
                {activeRecipients.apiSucceded
                    ? (
                        <ul>
                            <li>
                                <strong>
                                    Średnia miesięczna liczba aktywnych odbiorców usługi Cenojad.pl,
                                    której dostawcą jest RASP, wynosi: <span className="information">{activeRecipients.total}</span>
                                </strong>
                            </li>
                            <li>
                                <strong>
                                    Ostatnia aktualizacja: <span className="information">{activeRecipients.lastModifiedDate}</span>
                                </strong>
                            </li>
                        </ul>
                    )
                    : (
                        <p>
                            <strong>
                                Wystąpił problem z komunikacją z serwerem google analytics
                            </strong>
                            <br />
                            <br />
                            <strong>
                                Spróbuj ponownie później
                            </strong>
                        </p>
                    )}
                <p>
                    Liczba ta została obliczona na podstawie badania Mediapanel, dostarczanego przez Polskie Badania Internetu i Gemius,
                    z oszacowaniem liczby aktywnych odbiorców usługi spoza Polski, przygotowanym przez RASP, zgodnie z metodyką DSA.
                    Publikacja niniejsza jest realizowana wyłącznie w celu realizacji obowiązku z art.24.2. DSA.
                </p>
                <p>
                    Adres do kontaktu: <a href="mailto:ido@ringieraxelspringer.pl">ido@ringieraxelspringer.pl</a>
                </p>
                <h2>Single Point of Contact:</h2>
                <p className="italic">
                    Jeden Punkt Kontaktowy: <a href="mailto:SPOC@ringieraxelspringer.pl">SPOC@ringieraxelspringer.pl</a> wyznaczony do
                    bezpośredniej komunikacji zgodnie z Aktem o Usługach Cyfrowych dla organów państw członkowskich, Komisji Europejskiej
                    i Rady Usług Cyfrowych, oraz Użytkowników usług pośrednich. Komunikacja obsługiwana w języku polskim lub angielskim.
                </p>
                <p className="italic">
                    Single Point of Contact: <a href="mailto:SPOC@ringieraxelspringer.pl">SPOC@ringieraxelspringer.pl</a> designated for
                    direct communication in accordance with the Digital Services Act for Member State authorities, the European Commission
                    and the Digital Services Board, and also for intermediary services Users. Communication supported in Polish or English.
                </p>
            </PageSectionBox>
        </section>
    );
};

export default DigitalServicesActBase;
